import { viewarticleTypes } from '../constants/ActionType';

export const ArtclActionCreators = {
  landing: (articleData) => ({ type: viewarticleTypes.LANDING, payload: { articleData } }),
  artclOptions: (artclOptionsData) => ({ type: viewarticleTypes.ARTICLEOPTIONS, payload: { artclOptionsData } }),
  filterSite: (selectedSite) => ({ type: viewarticleTypes.SELECTEDSITE, payload: { selectedSite } }),
  filterParty: (selectedParty) => ({ type: viewarticleTypes.SELECTEDPARTY, payload: { selectedParty } }),
  filterArtilce: (data) => ({ type: viewarticleTypes.TEXTFILTER, payload: { data } }),
  masterBrand: (data) => ({ type: viewarticleTypes.MASTERBRAND, payload: { data } })
}